import {makeObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {UserAdditionalDataModel} from '../common/UserAdditionalData/UserAdditionalData.model';
import type {CourseModel} from '../Course/Course.model';
import type {DateTimeModel} from '../Date/DateTime.model';
import type {UserModel} from '../User/User.model';

import {BaseModel} from '../../../core/domain/Base/Base.model';

const ModelName = 'CoachHistoryModel';

export class CoachHistoryModel extends BaseModel {
  additionalData: Nullable<UserAdditionalDataModel>;
  client: UserModel;
  course: Nullable<CourseModel>;
  createdDate: DateTimeModel;
  currentCoach: UserModel;
  endDate: DateTimeModel;
  newCoach: Nullable<UserModel>;
  reason: string;
  startDate: DateTimeModel;
  status: CoachHistoryModel.Status;
  type: CoachHistoryModel.Type;
  updatedDate: DateTimeModel;

  constructor(props: CoachHistoryModel.Props) {
    super(props);

    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<
        CoachHistoryModel,
        CoachHistoryModel.Props
      >(props),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace CoachHistoryModel {
  export enum Status {
    ASSIGNED = 'assigned',
    CREATED = 'created',
    DISAGREED = 'disagreed',
    MESSAGE_SENT = 'message_sent',
    ONGOING = 'ongoing',
    PAST = 'past',
    READY_TO_CHANGE = 'ready_to_change',
  }

  export enum Type {
    CHANGED_AUTOMATICALLY = 'changed_automatically',
    CHANGED_BY_COACH = 'changed_by_coach',
    CHANGED_BY_USER = 'changed_by_user',
    COACH_COVERAGE = 'coach_coverage',
    MATCHED = 'matched',
    STOPPED = 'stopped',
  }

  export type Props = BaseModel.ModelToProps<CoachHistoryModel>;
}
